import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Roles } from '../../constant/roles';
import { UserStore } from '../../store/user.store';

import { RoleService } from '../../service/role.service';

@Injectable({
    providedIn: 'root'
})
export class CheckAdminOrHr implements CanLoad, CanActivate {
    constructor(private router: Router, private roleService: RoleService, private usrStore: UserStore) {
    }

    async canLoad() {
        console.log('CheckAdminOrHr => canLoad');
        return this.roleService.hasHRorAdmin();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        console.log('CheckAdminOrHr => check canActivate');
        if (this.roleService.hasHRorAdmin())
            return true;
        else {
            let page = '/login';
            if (this.usrStore.userLogged) {
                page = '/app/tabs/home';
            } 
            this.router.navigate([page]);
            return false;
        }
    }
}
